export default "__VITE_ASSET__U_VtJHg0__"